import React from 'react';
import type { IconProps } from '@makemydeal/dr-ui-bricks-types';
import { StyledIcon } from './icon.style';

const Icon: React.FC<IconProps> = ({ svg, width = 18, height = 19, className }) => {
    return (
        <StyledIcon className={className} width={width} height={height}>
            {svg}
        </StyledIcon>
    );
};

export default Icon;
